import React from 'react';
import { CustomAltMan, CustomColumnQuantPc, CustomColumnPorcAnt, CustomColumnPorcAntVendaFutura } from './Components';
import { atualizaPercEstSeg, atualizaQuantidade } from '../../../../services/DadoMestreService';
import { getPlanilhaPlanejamentoSku } from '../../../../services/TonyService';
import FileSaver from 'file-saver';

export const styles = {
    modal: { height: '70vh' },
    table: {
        WebkitTouchCallout: 'none',
        WebkitUserSelect: 'none',
        KhtmlUserSelect: 'none',
        MozUserSelect: 'none',
        msUserSelect: 'none',
        userSelect: 'none',
    },
    bold: {
        fontWeight: 700,
    },
    cell: (width, odd) => ({
        width: width,
        background: odd ? '#f0f0f0' : '#fff',
        cursor: 'pointer',
    }),
    autoSizer: (width, height) => ({ width: width, height: height }),
};

export const getItemsOnPaste = (rows, name, i, data) => {
    const quantidadeDeInputsDiponiveis = data.length - i;

    if (rows.length - 1 > quantidadeDeInputsDiponiveis) rows.slice(0, quantidadeDeInputsDiponiveis);

    return rows
        .map((value, index) => {
            if (!/^\d+$/.test(parseFloat(value))) return null;

            const newData = { ...data[parseInt(index) + i] };
            newData[name] = value;
            return constroiObjeto(newData)[name];
        })
        .filter((row) => row);
};

export const getAllItems = (rows) =>
    rows.map((row) => ({
        material: row.material,
        data: row.data,
        estacao: row.estacao,
        colecao: row.colecao,
        percentual: 0,
        grade: row.grade,
    }));

export const constroiObjeto = (row) => ({
    qtdProgramada: {
        material: row.material,
        data: row.data,
        estacao: row.estacao,
        colecao: row.colecao,
        quantidade: row.qtdProgramada,
        grade: row.grade,
    },
    percAnt: {
        material: row.material,
        data: row.data,
        estacao: row.estacao,
        colecao: row.colecao,
        percentual: row.percAnt,
        grade: row.grade,
    },
    percAntVendaFutura: {
        material: row.material,
        data: row.data,
        estacao: row.estacao,
        colecao: row.colecao,
        percentual: row.percAntVendaFutura,
        grade: row.grade,
        vendaFutura: true,
    },
    percEstoqueSeg: {
        material: row.material,
        data: row.data,
        estacao: row.estacao,
        colecao: row.colecao,
        percentual: row.percEstoqueSeg,
        grade: row.grade,
    },
});

export const canBeUpdate = (data, value, column, i) =>
    ['qtdProgramada', 'percAnt', 'percAntVendaFutura', 'percEstoqueSeg'].includes(column) &&
    value &&
    data[i][column + 'Original'] !== value[column];

export const onCopy = (data, selection) =>
    document.addEventListener('copy', (e) => {
        e.preventDefault();

        if (data.length === 0) return;

        const value = selection.copy
            .map((cols) =>
                cols
                    .map((col) => {
                        const column = columns[col.y].name;
                        const value = data[col.x][column];

                        if (columns[col.y].copy) {
                            return columns[col.y].copy(data[col.x]) || '';
                        }

                        return value === undefined || value === null ? '' : value;
                    })
                    .join('\t')
            )
            .join('\n');
        e.clipboardData.setData('text/plain', value);
    });

export const caseUpdateLine = async (name, value) => {
    switch (name) {
        case 'qtdProgramada':
        case 'percAnt':
            return atualizaQuantidade(value);
        case 'percAntVendaFutura':
            return atualizaQuantidade(value);
        case 'percEstoqueSeg':
            return atualizaPercEstSeg(value);
        default:
            return Promise.reject(null);
    }
};

export const getPlanilha = async (filter, tabelas, opcoesFiltradas) => {
    const convert = (result) => {
        var buf = new ArrayBuffer(result.length); //convert s to arrayBuffer
        var view = new Uint8Array(buf); //create uint8array as viewer
        for (var i = 0; i < result.length; i++) view[i] = result.charCodeAt(i) & 0xff; //convert to octet
        return buf;
    };

    filter.tabelas = tabelas;
    filter.opcoesFiltradas = opcoesFiltradas;

    const result = await getPlanilhaPlanejamentoSku(filter);
    FileSaver.saveAs(new Blob([convert(result)], { type: 'application/octet-stream' }), 'Sku.xlsx');
};

export const getColumnWidth = (props) => columns[props.index].width;

export const columns = [
    {
        name: 'grade',
        label: 'SKU',
        width: 70,
        cell: (line) => line.grade,
    },
    // {
    //     name: 'naoPrograma',
    //     label: 'NP',
    //     width: 70,
    //     cell: (i, line) => {
    //         return (
    //             <Input
    //                 type='checkbox'
    //                 id={'naoPrograma' + i}
    //                 name={'naoPrograma' + i}
    //                 checked={line.line.naoPrograma}
    //                 readOnly={true}
    //                 disabled={false}
    //                 style={{
    //                     marginTop: 0,
    //                     marginLeft: 0,
    //                 }}
    //             />
    //         );
    //     },
    // },
    {
        name: 'estacao',
        label: 'Est.',
        width: 40,
        cell: (line) => line.estacao,
    },
    {
        name: 'colecao',
        label: 'Col.',
        width: 40,
        cell: (line) => line.colecao,
    },
    {
        name: 'saldoPositivo',
        label: 'Saldo +',
        width: 60,
        sum: true,
        cell: (line) => line.saldoPositivo,
    },
    {
        name: 'saldoNegativo',
        label: 'Saldo -',
        width: 60,
        sum: true,
        cell: (line) => line.saldoNegativo,
    },
    {
        name: 'data',
        label: 'Dt.Remessa',
        width: 70,
        cell: (line) => new Date(line.data + 'T00:00:00').toLocaleDateString('pt-BR'),
    },
    {
        name: 'pv',
        label: 'P.V',
        width: 50,
        cell: (line) => line.pv,
    },
    {
        name: 'estoqueInicial',
        label: 'Est.Ini. \n(+)',
        width: 60,
        sum: true,
        cell: (line) => line.estoqueInicial,
    },
    {
        name: 'qtdEstoqueProdPed',
        label: 'WIP\n(+)',
        width: 60,
        sum: true,
        cell: (line) => line.qtdEstoqueProdPed,
    },
    {
        name: 'qtdWipFuturo',
        label: 'Wip Futuro',
        width: 60,
        sum: true,
        cell: (line) => line.qtdWipFuturo,
    },
    {
        name: 'alteracaoManual',
        label: 'Alt.Man',
        width: 60,
        cell: (line) => <CustomAltMan line={line} />,
    },
    {
        name: 'qtdProgramadaManual',
        label: 'Qtd.Pçs\nProg. Manual',
        width: 90,
        sum: true,
        cell: (line) => line.qtdProgramadaManual,
    },
    {
        name: 'qtdProgramada',
        label: 'Qnt. Pçs\n(+)',
        width: 70,
        sum: true,
        cell: (line, render) => <CustomColumnQuantPc line={line} render={render} />,
    },
    {
        name: 'percAnt',
        label: '% Ante.',
        width: 60,
        cell: (line, render) => <CustomColumnPorcAnt line={line} render={render} />,
    },
    {
        name: 'percAntVendaFutura',
        label: '% Ante. Venda Futura',
        width: 90,
        cell: (line, render) => <CustomColumnPorcAntVendaFutura line={line} render={render} />,
    },
    {
        name: 'qtdProgSemMulti',
        label: 'Qnt.Prog.SMulti',
        width: 80,
        sum: true,
        cell: (line) => line.qtdProgSemMulti,
    },
    {
        name: 'percAntSemMulti',
        label: '%Ante.S.M',
        width: 80,
        cell: (line) => line.percAntSemMulti,
    },
    {
        name: 'qtdProgSemIgua',
        label: 'Qnt.Prog.SIgua',
        width: 80,
        sum: true,
        cell: (line) => line.qtdProgSemIgua,
    },
    {
        name: 'percAntSemIgua',
        label: '%Ante.S.I',
        width: 80,
        cell: (line) => line.percAntSemIgua,
    },
    {
        name: 'aplicouMI',
        label: 'Aplicação MI',
        width: 80,
        cell: (line) => (line.aplicouMI ? 'SIM' : ''),
    },
    {
        name: 'aplicouConjuntar',
        label: 'Aplicação Conjuntar',
        width: 80,
        cell: (line) => (line.aplicouConjuntar ? 'SIM' : ''),
    },
    {
        name: 'saldoDescasado',
        label: 'Saldo descasado',
        width: 80,
        sum: true,
        cell: (line) => line.saldoDescasado,
    },
    {
        name: 'percEstoqueSeg',
        label: '% Est.Seg.',
        width: 70,
        cell: (line) => line.percEstoqueSeg,
    },
    {
        name: 'estoqueSeguranca',
        label: 'Est.Seg\n(-)',
        width: 70,
        sum: true,
        cell: (line) => line.estoqueSeguranca,
    },
    {
        name: 'qtdFaltaEstoqueSeguranca',
        label: 'Falta PE\n(-)',
        width: 70,
        sum: true,
        cell: (line) => line.qtdFaltaEstoqueSeguranca,
    },
    {
        name: 'qtdPecasEstoqueSeguranca',
        label: 'Programação PE',
        width: 70,
        sum: true,
        cell: (line) => line.qtdPecasEstoqueSeguranca,
    },
    {
        name: 'qtdAlocada',
        label: 'Qtd.Alocada',
        width: 70,
        sum: true,
        cell: (line) => line.qtdAlocada,
    },
    {
        name: 'vendaDescoberta',
        label: 'Venda Desc',
        width: 70,
        sum: true,
        cell: (line) => line.vendaDescoberta,
    },
    {
        name: 'qtdVenda',
        label: 'Venda R.\n(-)',
        width: 70,
        sum: true,
        cell: (line) => line.qtdVenda,
    },
    {
        name: 'qtdVendaTotal',
        label: 'Venda T.\n(-)',
        width: 70,
        sum: true,
        cell: (line) => line.qtdVendaTotal,
    },
    {
        name: 'qtdPrevisao',
        label: 'Prev.\n(-)',
        width: 60,
        sum: true,
        cell: (line) => line.qtdPrevisao,
    },
    {
        name: 'qtdPrevisaoTotal',
        label: 'Prev. T\n(-)',
        width: 60,
        cell: (line) => line.qtdPrevisaoTotal,
    },
    {
        name: 'qtdSegundaQualidade',
        label: 'RA-2º Qual\n(-)',
        width: 75,
        sum: true,
        cell: (line) => line.qtdSegundaQualidade,
    },
    {
        name: 'guardarCalculado',
        label: 'Sobra Guardar',
        width: 93,
        sum: true,
        cell: (line) => line.guardarCalculado,
    },
    {
        name: 'guardar',
        label: 'Guardar\n(-)',
        width: 60,
        sum: true,
        cell: (line) => line.guardar,
    },
    {
        name: 'multiplo',
        label: 'Múltiplo\n(-)',
        width: 60,
        sum: true,
        cell: (line) => line.multiplo,
    },
    {
        name: 'necessidadeCalculada',
        label: 'Nec.',
        width: 80,
        sum: true,
        cell: (line) => line.necessidadeCalculada,
    },
    {
        name: 'necessidadeMultiplo',
        label: 'Nec. Mult.',
        width: 60,
        sum: true,
        cell: (line) => line.necessidadeMultiplo,
    },
    {
        name: 'qtdProgramadaPrevisao',
        label: 'Nec. Ant. Previsão',
        width: 90,
        sum: true,
        cell: (line) => line.qtdProgramadaPrevisao,
    },
    {
        name: 'qtdProgramadaVenda',
        label: 'Nec. Ant. Venda',
        width: 90,
        sum: true,
        cell: (line) => line.qtdProgramadaVenda,
    },
    {
        name: 'somaNecessidades',
        label: 'Soma das Antecipações',
        width: 90,
        sum: true,
        cell: (line) => line.somaNecessidades,
    },
    {
        name: 'necessidadeCalculadaPrevisao',
        label: 'Nec. Ant. Previsão',
        width: 70,
        sum: true,
        cell: (line) => line.necessidadeCalculadaPrevisao,
    },
    {
        name: 'necessidadeCalculadaVenda',
        label: 'Nec. Ant. Venda',
        width: 70,
        sum: true,
        cell: (line) => line.necessidadeCalculadaVenda,
    },
    {
        name: 'somaNecessidades',
        label: 'Soma das necessidades',
        width: 80,
        sum: true,
        cell: (line) => line.somaNecessidades,
    },
    {
        name: 'saldoQtdAnt',
        label: 'Saldo Qtd. Ant.',
        width: 80,
        sum: true,
        cell: (line) => line.saldoQtdAnt,
    },
    {
        name: 'estoqueFinal',
        label: 'Est. Final\n(=)',
        width: 61,
        sum: true,
        cell: (line) => line.estoqueFinal,
    },
    {
        name: 'estoqueFinalFechamento',
        label: 'Est.Final\nFechamento',
        width: 70,
        sum: true,
        cell: (line) => line.estoqueFinalFechamento,
    },
    {
        name: 'saldoCobertura',
        label: 'Saldo Cober.\n(=)',
        width: 90,
        sum: true,
        cell: (line) => line.saldoCobertura,
    },
    {
        name: 'qtdGastar',
        label: 'Gastar',
        width: 90,
        sum: false,
        cell: (line) => {
            if (line.qtdGastar == -1) {
                return '';
            } else {
                return line.qtdGastar;
            }
        },
    },
    {
        name: 'coberturaEstoque',
        label: 'Cob.Est.(%)\n(=)',
        width: 76,
        copy: (line) =>
            (line.coberturaEstoque > 0 ? line.coberturaEstoque : 0).toLocaleString('pt-BR', {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
            }),
        cell: (line) =>
            (line.coberturaEstoque > 0 ? line.coberturaEstoque : 0).toLocaleString('pt-BR', {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
            }),
    },
    {
        name: 'observacao',
        label: 'Observação',
        width: 95,
        cell: (line) => line.observacao,
    },
];
